import router from '../router'
import axios from 'axios'
import store from '@/store'
import { getToken, getAuth } from '@/utils/auth'
import { ElMessage, ElMessageBox } from 'element-plus'

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
let unauthorized = false;
// 声明CancelToken
var CancelToken = axios.CancelToken;
// 声明全局请求数组
window.requests = [];
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_API,
  // 超时
  timeout: 30000,
  withCredentials: false
})
// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken && config.url.indexOf('/zngw-api') == -1) {
      config.headers['Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (getAuth() && config.url.indexOf("zngw-api") <= 0) {
      config.headers['Authorization'] = getAuth()
    }

    if (config.url.indexOf('/zngw-api') > -1) {
      config.headers['Authorization'] = ''

    }

    //  设置类型改为内部设置，解决urtp接口415
    // config.headers['Content-Type'] = 'application/json;charset=utf-8'

    // 以下为批量终止请求做的修改
    let source = CancelToken.source() // 申明CancelToken,也可new CancelToken.source()实例一个
    config.cancelToken = source.token //讲实例对象的token赋予该请求
    window.requests.push({ url: config.url, xhr: source })
    return config
  },
  error => {
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
  let code = res.data.code || res.code
  if (code === 402) {
    store.dispatch('FedLogOut').then(() => {
      ElMessageBox.alert("登录状态已过期，请您重新登录！");
      router.push('/login')
    })
  } else if (code !== 200) {
    return res.data;
  } else {
    unauthorized = false;
    return res.data
  }
},
  error => {
    if (error.response.status === 402) {
      router.push('/login')
    }
    if (error.response.status === 401) { // token失效 ,重新获取token
      unauthorized = true;
      ElMessageBox.confirm(
        '登录状态已过期，请您重新登录！',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {

        })
      }).catch(() => {
        unauthorized = false;
      })
    } else if (error.response.status === 500) { // 服务器断开
      ElMessageBox.alert('溯源接口异常1，错误码：' + error.response.status);
    } else if (error.response.status === 403) { //无auth授权，后台不允许访问
      ElMessageBox.alert("对不起，您的权限不足，操作失败！");
    }
    else {
      ElMessageBox.alert('溯源接口异常2，错误码：' + error.response.status);
    }
  }
)

export default service
